module.exports = {"key":"hello german","submit":"SkickaFeedback!","hide":"Dölj detta","skip":"Hoppa till nästa fråga","placeholder":"Var god beskriv hur du känner inför detta..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/sv.json
// module id = 447
// module chunks = 0